export enum TransitionState {
    Enter,
    Leave,
    EnterTo,
    Inactive
}
